// extracted by mini-css-extract-plugin
export default {"content":"rE-z"};